import { Copy, UtensilsCrossed, ListX } from "lucide-react";
import { FadeUp } from "./FadeUp";

const PROBLEMS = [
  {
    id: "generic-plans",
    icon: Copy,
    title: "Generic plans",
    desc: "Copied plans don't fit your body or your goal.",
  },
  {
    id: "no-indian-food",
    icon: UtensilsCrossed,
    title: "No Indian food",
    desc: "Plans full of foods you never eat.",
  },
  {
    id: "no-tracking",
    icon: ListX,
    title: "No tracking",
    desc: "You lose track in the gym and give up.",
  },
];

export const ProblemSection = () => (
  <section className="py-14 md:py-20 px-6 bg-[#111113]">
    <div className="max-w-6xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10 md:mb-12">
          WHY MOST FITNESS PLANS FAIL
        </h2>
      </FadeUp>
      <div className="grid md:grid-cols-3 gap-6">
        {PROBLEMS.map((p, i) => (
          <FadeUp key={p.id} delay={i * 0.1}>
            <div
              data-testid={`problem-card-${p.id}`}
              className="bg-[#141416] border border-[#232326] rounded-[24px] p-8 h-full hover:-translate-y-1.5 hover:border-[#C6FF3D]/40 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-[#C6FF3D]/10 flex items-center justify-center mb-6">
                <p.icon className="text-[#C6FF3D]" size={22} />
              </div>
              <h3 className="text-white text-xl font-semibold mb-2">{p.title}</h3>
              <p className="text-[#A1A1AA] text-sm">{p.desc}</p>
            </div>
          </FadeUp>
        ))}
      </div>
      <FadeUp delay={0.3}>
        <p className="text-center mt-10 font-display text-2xl sm:text-3xl text-[#C6FF3D]">
          FORGE fixes all three.
        </p>
      </FadeUp>
    </div>
  </section>
);
